import Checkbox from './Checkbox';
import Group from './Group';
Checkbox.Group = Group;
export default Checkbox;


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/checkbox/index.js
// module id = 225
// module chunks = 0